/** Espelha public.tipo_automacao (db_compras) e `TipoAutomacaoEnum` da API Compras: catálogo fixo de automações do Kanban de Compras. */
export enum TipoAutomacaoEnum {
  EnviarCotacaoFornecedor = 1,
  EnviarPedidoFornecedor = 2,
  AtualizarSaldoEstoque = 3,
  GerarContasPagar = 4,
  MoverAutomaticamente = 5,
  Notificar = 6,
}
